<template>
  <!-- class="message-overlay message-overlay_blurred" -->
  <!-- { mso_radial: isRadial }, -->
  <!-- { mso_full: !isRadial && !isTopDown }, -->
  <!-- :class="[
      { mso_blurred: isBlurred },
      { mso_full: !isTopDown },
      { 'mso_top-down': isTopDown }
    ]" -->
  <div class="message-overlay-skeleton mso">
    <div class="mso_content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MessageOverlaySkeleton',
  props: {
    isBlurred: Boolean,
    isTopDown: Boolean,
  },
}
</script>

<style lang="scss" scoped>
.mso {
  position: absolute;
  flex: 1;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--z-index-dialog);
  --opacity: 0.44;
  --back-from: rgba(0, 0, 0, var(--opacity));
  --back-to: transparent;
  // --content-margin: auto;
  --radius: 0;
  padding: 0.5rem;
  top: 0;
  left: 0;
  border-radius: var(--radius);
  --before-back: var(--back-from);
  &::before {
    content: '';
    position: absolute;
    // top: 0;
    // left: 0;
    width: 100%;
    height: 100%;
    background: var(--before-back);
    border-radius: var(--radius);
    z-index: 0;
  }
  &_content {
    // margin: var(--content-margin);
    // position: relative;
    z-index: 1;
  }
  &_blurred {
    &:before {
      backdrop-filter: blur(8px);
      // mask: linear-gradient(to top, black, rgba(0, 0, 0, 0) 250%);
    }
  }
  &_circleshadow {
    &:before {
      // display: none;
      height: 0px;
      width: 0px;

      position: absolute;
      border-radius: 50%;
      box-shadow: 0px 0px 17vh 22vh black;
      // box-shadow: 0px 0px 17vh 22vh red;
      // backdrop-filter: blur(8px);
      // background: radial-gradient(black 10%, transparent);
      // background: red;
      // width: 100%;
      // height: 100%;
    }
  }
  // &_blurred_gradient {
  //   &:before {
  //     backdrop-filter: blur(8px);
  //   }
  // }
  &_full {
    // background: var(--back-from);
    --before-back: var(--back-from);
  }
  &_top-down {
    --before-back: linear-gradient(180deg, var(--back-from), var(--back-to));
    // background: linear-gradient(180deg, var(--back-from), var(--back-to));
  }
}
</style>
